var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "single-column-wrapper",
      staticStyle: { "max-width": "880px", margin: "auto" }
    },
    [_c("div", { staticClass: "column-body" }, [_vm._t("column-body")], 2)]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }